import { IS_NOT_EMPTY } from '../../utils';
import { ProjectDTO } from '../dtos';

export const GET_LANE_PATH_STRING = (project: ProjectDTO): string => {
	let result = '';
	if (
		IS_NOT_EMPTY(project.originCity) &&
		IS_NOT_EMPTY(project.originState) &&
		IS_NOT_EMPTY(project.destCity) &&
		IS_NOT_EMPTY(project.destState) &&
		IS_NOT_EMPTY(project.equipmentType)
	) {
		result =
			project.originCity +
			', ' +
			project.originState +
			' -> ' +
			project.destCity +
			', ' +
			project.destState +
			' (' +
			project.equipmentType.split(', ').map((e) => e.toUpperCase()) +
			')';
	}
	return result;
};
